import './init';
import { WBFlex } from '@admiin-com/ds-web';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import ApolloClientProvider from './app/components/ApolloClientProvider/ApolloClientProvider';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  //<StrictMode>

  <ApolloClientProvider>
    <BrowserRouter>
      <Suspense fallback={<WBFlex />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </ApolloClientProvider>
  //</StrictMode>
);
